module.exports = __webpack_public_path__ + "img/bottom-tips.45dc05d5.webp";